import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/nextjs';
import api from 'utils/api';
import type { SessionTag } from 'components/Ponder/TagPicker';

/** `null` until the vocabulary has loaded; an empty list if it could not be loaded. */
export default function useSessionTags(): SessionTag[] | null {
  const [tags, setTags] = useState<SessionTag[] | null>(null);

  useEffect(() => {
    let isCurrent = true;
    api()
      .get('/users/workout/session-tags')
      .then(({ data }: { data: SessionTag[] }) => {
        if (isCurrent) setTags(data);
      })
      .catch((error: unknown) => {
        Sentry.captureException(error);
        if (isCurrent) setTags([]);
      });
    return () => {
      isCurrent = false;
    };
  }, []);

  return tags;
}
